module.exports = __webpack_public_path__ + "img/Скобка_general_value_bot.63185c94.svg";